"use client"

import { useQuery } from "@tanstack/react-query"
import { useAuth } from "@/hooks/use-auth"
import { listAgentCreationKnowledgeAction } from "@/server-actions/agent-creation"
import type { CreationAgentType } from "@/lib/agents/creation/types"

export function useAgentCreationKnowledgeQuery(type: CreationAgentType, enabled: boolean) {
  const { user, isLoading } = useAuth()
  const tenantId = user?.impersonated_tenant_id ?? user?.tenant_id
  return useQuery({
    queryKey: ["agent-creation-knowledge", user?.user_id, tenantId, type], enabled: enabled && !isLoading && Boolean(user?.user_id) && Boolean(tenantId), queryFn: async () => {
      const result = await listAgentCreationKnowledgeAction({ type })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    }
  })
}
